<div class="menu-container">

    <div class="menu-header">
        <div class="back-arrow">
            <button class="dotted-arrow" mat-icon-button (click)="closeSelectNewQuote()">←</button>
        </div>
        <h3 class="headline" i18n="@@choose-quote_select">Select quote</h3>
    </div>

    <div class="menu-list">
        <ng-container *ngIf="quotes.length > 0">
            <div class="quote" *ngFor="let quote of quotes" (click)="changeSelectedQuote($event.target)" id="{{quote.id}}">
                {{quote.name}}
            </div>
        </ng-container>
        <ng-container *ngIf="quotes.length === 0">
            <div i18n="@@choose-quote_no-quotes" class="no-quotes">No Quotes</div>
        </ng-container>
    </div>
</div>
